module.exports = __webpack_public_path__ + "img/wordle-2.8ddeaac3.svg";